// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"2b5419bf","823":"59b7169e"}[chunkId] + ".chunk.js";
};